import Dashboard from "./components/Dashboard";
import SkillsList from "./components/SkillsList";
import EmployeeDetailPage from "./components/EmployeeDetailPage";
import UserSkillDashboard from "./components/UserSkillDashboard";
import TeamCompetencyDashboard from "./components/TeamCompetencyDashboard";
import UnfreezePage from "./components/UnfreezePage";
import AdminReport from "./components/AdminReport";
import AdminExtraFunctions from "./components/AdminExtraFunctions";
import BenchReport from "./components/BenchReport";
import SkillSetReports from "./components/SkillSetReports";
import TokenLogin from "./components/TokenLogin";

/*
 * `title` is the browser tab title for the route. It is applied centrally by
 * <DocumentTitle> in App.js so every view has a descriptive, page-specific
 * title and no page can leave a stale one behind (SM-ACX-013, SM-GEN-002).
 */
const routes = [
    { path: "/token-login", label: "Token Login", title: "Signing in", element: TokenLogin },
    { path: "/home", label: "Home", title: "Home", element: UserSkillDashboard },

    {
        path: "/dashboard",
        label: "Skill Performance Dashboard (Self)",
        title: "My Skill Performance",
        element: Dashboard,
    },

    { path: "/skills", label: "Skill Tracker", title: "Skill Tracker", element: SkillsList },

    // Parent menu — no routePath comes back from the server for it, so the
    // group gets this landing page instead of being a dead link (SM-HR-009).
    {
        path: "/skill-set-reports",
        label: "Skill Set Reports",
        title: "Skill Set Reports",
        element: SkillSetReports,
        isGroupLanding: true,
        children: [
            { path: "/AdminReport", label: "Admin Report", title: "Employee Skill Report", element: AdminReport },
            { path: "/BenchReport", label: "Bench Report", title: "Bench Report", element: BenchReport },
            { path: "/AdminExtraFunctions", label: "Admin Extra Functions", title: "Admin Extra Functions", element: AdminExtraFunctions },
        ],
    },

    {
        path: "/teamcompetencydashboard",
        label: "Team Competency Dashboard",
        title: "Team Competency Dashboard",
        element: TeamCompetencyDashboard,
    },

    { path: "/unfreezepage", label: "UnfreezePage", title: "Unfreeze Management", element: UnfreezePage },

    {
        path: "/employee/:employeeId",
        label: "Employee Detail",
        title: "Employee Review",
        element: EmployeeDetailPage,
    },
];

/** Every navigable route, group landing pages included. */
export const allRoutes = routes.flatMap(route =>
    route.children
        ? [...(route.element ? [route] : []), ...route.children]
        : (route.element ? [route] : [])
);

export default routes;
